import _toConsumableArray from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = ["onClick"];
import { useRoute } from 'vue-router';
import useClipboard from 'vue-clipboard3';
import authWrap from './components/authWrap';
import searchBanner from './components/searchBanner';
import commonTable from './components/commonTable';
import DtMessage from '@/components/DtMessage';
import { myApplyHeader } from './commons/tableHeader';
import AuthService from '@/api/auth';
import { ref, reactive, onMounted, watch, computed } from 'vue';
import { getApprovalHistoryDesc } from './commons/authUtil';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _window$AppConfig$aut;

    var route = useRoute();

    var _useClipboard = useClipboard(),
        toClipboard = _useClipboard.toClipboard;

    var appKey = computed(function () {
      return route.params.project;
    });
    var tableHeader = ref(myApplyHeader);
    var searchParams = reactive({
      appKey: appKey.value || '',
      applyStatus: 'APPROVING',
      keyword: '',
      pageNo: 1,
      pageSize: 10
    });
    var tableOptions = reactive({
      loading: false,
      pagination: true,
      total: 0,
      selectedRow: null
    });
    var tableBody = reactive([]);
    var enableApplyPush = ref((_window$AppConfig$aut = window.AppConfig.authority) === null || _window$AppConfig$aut === void 0 ? void 0 : _window$AppConfig$aut.enableApplyPush);

    var searchList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(applyStatus, keyword) {
        var _data$data;

        var data, result, tableBodyTemp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (applyStatus) {
                  Object.assign(searchParams, {
                    pageNo: 1,
                    pageSize: 10,
                    applyStatus: applyStatus,
                    keyword: keyword
                  });
                }

                tableOptions.loading = true;
                _context.next = 4;
                return AuthService.getApplyList(searchParams);

              case 4:
                data = _context.sent;
                tableOptions.loading = false;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  result = data.data.result;
                  tableOptions.total = result.totalCount;
                  tableBodyTemp = result.itemList || [];
                  tableBodyTemp.forEach(function (item) {
                    var otherObj = getApprovalHistoryDesc(item.approvalHistory, item.approvalStep); // 变更的权限类型为空，则取申请的权限类型

                    if (!otherObj.realAuthType) otherObj.realAuthType = item.actionDesc || item.roleName;
                    Object.assign(item, {
                      modifyName: item.actionDesc || item.roleName,
                      modifyId: item.action || item.roleId,
                      modifyList: []
                    }, otherObj);
                  });
                  tableBody.length = 0; // 清空原数组

                  tableBody.push.apply(tableBody, _toConsumableArray(tableBodyTemp)); // 解构然后push进去
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function searchList(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(); // 切换审核状态


    var onSearchHandler = function onSearchHandler(key, value) {// searchParams[key] = value;
      // searchList({ pageNo: 1 });
    };

    var copyCon = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(applyId) {
        var _data$data2;

        var data, _data$data3;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return AuthService.repush({
                  applyId: applyId
                });

              case 2:
                data = _context2.sent;

                if (!(((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1)) {
                  _context2.next = 15;
                  break;
                }

                _context2.prev = 4;
                _context2.next = 7;
                return toClipboard("".concat(location.origin, "/authority/").concat(route.params.biz_url, "/approveDetail/").concat(applyId));

              case 7:
                DtMessage({
                  type: 'success',
                  message: '已向当前审批人再次发送企业微信通知，同时也已复制审批链接，若紧急可以将复制的链接主动发给审批人'
                });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);
                console.error(_context2.t0);

              case 13:
                _context2.next = 16;
                break;

              case 15:
                if ((_data$data3 = data.data) !== null && _data$data3 !== void 0 && _data$data3.msg) {
                  DtMessage({
                    type: 'warning',
                    message: data.data.msg
                  });
                }

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 10]]);
      }));

      return function copyCon(_x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    watch(function () {
      return appKey.value;
    }, function (newKey) {
      searchParams.appKey = newKey;
      searchList();
    });
    onMounted(function () {
      searchList();
    });
    return function (_ctx, _cache) {
      var _component_el_table_column = _resolveComponent("el-table-column");

      return _openBlock(), _createBlock(_unref(authWrap), {
        "search-params": _unref(searchParams),
        "title-text": "我的申请列表"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(searchBanner), {
            "search-params": _unref(searchParams),
            onOnSearch: searchList
          }, null, 8, ["search-params"]), _createVNode(_unref(commonTable), {
            params: _unref(searchParams),
            options: _unref(tableOptions),
            "table-header": tableHeader.value,
            "table-body": _unref(tableBody),
            onOnChangePage: searchList
          }, {
            default: _withCtx(function () {
              return [enableApplyPush.value && _unref(searchParams).applyStatus === 'APPROVING' ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "操作",
                width: "120"
              }, {
                default: _withCtx(function (scope) {
                  return [_createElementVNode("a", {
                    class: "link1",
                    onClick: function onClick($event) {
                      return copyCon(scope.row.id);
                    }
                  }, "催一催", 8, _hoisted_1)];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["params", "options", "table-header", "table-body"])];
        }),
        _: 1
      }, 8, ["search-params"]);
    };
  }
});